import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

const ForgotPasswordForm = ({ email, setEmail, handleSubmit, loading }) => {
  const { t } = useTranslation('login');
  const [openLangChange, setOpenLangChange] = useState(false);

  const handleLangeChangeClick = () => {
    setOpenLangChange(!openLangChange);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest('.change-language')) {
      setOpenLangChange(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div className="change-language">
        <LanguageSwitcher
          handleLangeChangeClick={handleLangeChangeClick}
          openLangChange={openLangChange}
          color="white"
        />
      </div>

      <h1>{t('FORGOTPASSWORD')}</h1>
      <p className="text-center mb-4 text-muted">
        {t('FORGOTPASSWORDDESCRIPTION')}
      </p>

      <div className="did-floating-label-content mb-4">
        <input
          className="did-floating-input"
          type="email"
          name="email"
          id="email"
          placeholder=" "
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label className="did-floating-label">{t('EMAILADDRESS')}</label>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="login btn btn-primary"
      >
        {loading ? t('SENDING') : t('SENDRESETLINK')}
      </button>

      <div className="text-center mt-3">
        <a href="/login" className="text-decoration-none">
          {t('BACKTOLOGIN')}
        </a>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
